import { z } from 'zod'
import { notificationResponseSchema } from './notification-response.schema'

export const notificationEventSchema = z.discriminatedUnion('type', [
  z.object({ type: z.literal('created'), notification: notificationResponseSchema }),
  z.object({ type: z.literal('read'), id: z.string() }),
  z.object({ type: z.literal('unread'), id: z.string() }),
  z.object({ type: z.literal('read-all') }),
  z.object({ type: z.literal('deleted'), id: z.string() }),
  z.object({ type: z.literal('deleted-read'), count: z.number().int().nonnegative() }),
  z.object({ type: z.literal('unread-count'), count: z.number().int().nonnegative() }),
  z.object({ type: z.literal('ping') }),
])

export type NotificationEvent = z.infer<typeof notificationEventSchema>

export const deleteResultSchema = z.object({
  count: z.number().int().nonnegative(),
})

export type DeleteResultDto = z.infer<typeof deleteResultSchema>
